import React from "react";
import { Add } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { toast } from "react-toastify";

import FormDrawer from "components/Shared/FormDrawer";

import { useVehicleDetailContext } from "contexts/VehicleDetailContext";

import VehicleMaintenanceForm from "../../VehicleMaintenance/VehicleMaintenanceComponents/VehicleMaintenanceForm";

import VehicleMaintenanceListByVehicle from "./VehicleMaintenanceListByVehicle";

import { useAddVehicleMaintenanceMutation, useUpdateVehicleMaintenanceMutation } from "store/services/vehicleMaintenanceApi";



const VehicleMaintenanceTab = () => {

  const [showMaintenanceForm, setShowMaintenanceForm] = React.useState(false);

  const [selectedMaintenance, setSelectedMaintenance] = React.useState(null);

  const { vehicleDetail } = useVehicleDetailContext();

  // RTK Query
  const [addVehicleMaintenance, { isLoading: addingMaintenance }] = useAddVehicleMaintenanceMutation();

  const [updateVehicleMaintenance, { isLoading: updatingMaintenance }] = useUpdateVehicleMaintenanceMutation();

  // Methods
  const handleCancelMaintenance = () => {
    setShowMaintenanceForm(false);
    setSelectedMaintenance(null);
  };

  const handleAddOrUpdateMaintenance = async (data) => {
    try {
      if (selectedMaintenance) {
        await updateVehicleMaintenance({
          vehicleId: vehicleDetail?._id,
          maintenanceId: selectedMaintenance._id,
          ...data,
        }).unwrap();
        toast.success("Maintenance updated successfully!");
      } else {
        await addVehicleMaintenance({
          vehicleId: vehicleDetail?._id,
          ...data,
        }).unwrap();
        toast.success("Maintenance added successfully!");
      }
      handleCancelMaintenance();
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't process maintenance!");
    }
  };

  return (
    <>
      <Box display="flex" justifyContent="end" padding={3}>
        {!showMaintenanceForm && (
          <Button
            startIcon={<Add />}
            variant="outlined"
            onClick={() => setShowMaintenanceForm(true)}
          >
            Add Maintenance
          </Button>
        )}
      </Box>

      <VehicleMaintenanceListByVehicle />

      <FormDrawer
        title="Vehicle Maintenance"
        open={showMaintenanceForm}
        onClose={handleCancelMaintenance}
      >
        <VehicleMaintenanceForm
          isBusy={addingMaintenance || updatingMaintenance}
          vehicleMaintenance={selectedMaintenance}
          onCancel={handleCancelMaintenance}
          onSubmit={handleAddOrUpdateMaintenance}
        />
      </FormDrawer>
    </>
  );
};

export default VehicleMaintenanceTab;